import { apiClient, borderUrl } from './http-common';
export function get(payload) {
    return new Promise((resolve, reject) => {
        apiClient.get(`${borderUrl}s`, { params: payload }).then((response) => {
            if (response.status === 200) {
                resolve(response.data);
            }
        });
    });
}
